import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import AdminAssessments from "../widgets/adminAssessments";

const AssesmentTemplatePortal = props => {
  return (
    <Portal>
      <PortalAppBar title="Assessment Portal" />
      <PortalGridContent>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <AdminAssessments />
        </Grid>
        <Grid item xs={12}></Grid>
      </PortalGridContent>
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AssesmentTemplatePortal));
